import { Component, input, output } from '@angular/core';

@Component({
  selector: 'filter-chip',
  imports: [],
  templateUrl: './filter-chip.component.html',
  styleUrl: './filter-chip.component.scss'
})
export class FilterChipComponent {
  text = input.required<string>();
  onClick = output<string>()
}
